import $ from 'jquery';

import '../../../scss/app/product.scss';
import { initializeProductDetail } from '../module/product/functions';

initializeProductDetail($('.product-detail'));
